/* jslint browser: true */
import React, { Component } from 'react';
import {apiUrl} from '../lib/constants';
import axios from 'axios';

import PaymentMethod from './commande/PaymentMethod';
import Credits      from './commande/Credits';

class Commande extends Component {
    constructor(props) {
        super(props);

        this.state = {
          credits       : [],
          credit : '',
          paymentMethod : '',
          paymentForm: ''
        };

        this.pay                    = this.pay.bind(this);
        this.onCreditChange         = this.onCreditChange.bind(this);
        this.onPaymentMethodChange  = this.onPaymentMethodChange.bind(this);
    }

    componentDidMount() {
        axios.get(apiUrl + '/api/v1/credit').then((response) => {
            let credits = response.data;
            let credit  = '';
            if(credits.length > 0) 
                credit = credits[0].id_credit;
            this.setState({
                credits: credits,
                credit: credit
            });
        });
    }

    onPaymentMethodChange(event) {
        this.setState({
            paymentMethod : event.target.value,
        });
    }

    onCreditChange(event) {
        this.setState({
            credit : event.target.value,
        });
    }

    pay() {
        axios.post(apiUrl + '/api/v1/commande', {
            id_credit: this.state.credit,
            description: ''
        }).then((response) => {
            this.setState({paymentForm: response.data});
            document.getElementById('paymentid').submit();
        });
    }

    render() {
        return (
            <div style={{marginTop: '20px'}}>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="col-sm-3"></div>
                            <div className="col-sm-6">
                                <Credits credits={this.state.credits} credit={this.state.credit} onCreditChange={this.onCreditChange}></Credits>
                            </div>
                            <div className="col-sm-3"></div>
                        </div>
                    </div>
               
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="col-sm-3"></div>
                            <div className="col-sm-6">
                                <PaymentMethod pay={this.pay} onPaymentMethodChange={this.onPaymentMethodChange}></PaymentMethod>
                                <div style={{display: 'none'}} dangerouslySetInnerHTML={{__html: this.state.paymentForm}}>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        );
    }
    
}

export default Commande;



// WEBPACK FOOTER //
// ./src/components/Commande.js